export default __webpack_public_path__ + "static/media/resume.5e05c871.svg";